import ExcludeFromLookup from '../../../../../../enums/ExcludeFromLookup';
import fieldTypes from '../../../../../../enums/FieldTypes';
import stripCharacters from '../../../../../utils/strip-characters';
import {onlyDeliveryAddresses} from '../../addressFormType';
import PredictionsByField from '../../PredictionsByField';
import validateAutocompleteField from '../../validateAutocompleteField';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import houseNameOrNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import streetName from '../../defaultFieldDefinitions/StreetName';
import townCity from '../../defaultFieldDefinitions/TownCity';
import * as max from '../../max-length-validators';
import * as required from '../../required-validators';
import {fiveDigitsPostcodeValidator} from '../../setDigitsPostcodeValidator';

const formatITPostcode = (value) => {
  if (!value) return value;
  return value.replace(/\s/g, '');
};

const provinces = PredictionsByField.county('IT');

const FieldDefinitionIT = [
  {
    name: 'firstName',
    label: 'checkout.delivery.address.field.label.first.name.text',
    filterCondition: onlyDeliveryAddresses,
    required: true,
    maxLength: 15,
    validate: [required.firstName, max.lengthAddressee(15)],
    excludeFromAddressLookup: ExcludeFromLookup.BEFORE,
  },
  {
    name: 'lastName',
    label: 'checkout.delivery.address.field.label.last.name.text',
    filterCondition: onlyDeliveryAddresses,
    required: true,
    maxLength: 18,
    validate: [required.lastName, max.lengthAddressee(20)],
    excludeFromAddressLookup: ExcludeFromLookup.BEFORE,
  },
  companyName,
  houseNameOrNumber,
  streetName,
  townCity,
  {
    name: 'county',
    label: 'checkout.address.field.label.county.text',
    required: true,
    element: fieldTypes.AUTOCOMPLETE,
    placeholder: 'checkout.delivery.address.field.placeholder.county.autoComplete',
    predictions: provinces,
    validate: [required.county, max.lengthAddress(35), validateAutocompleteField(provinces, 'county')],
  },
  {
    name: 'postCode',
    label: 'checkout.delivery.address.field.label.postal.code.text',
    required: true,
    maxLength: 5,
    transform: formatITPostcode,
    validate: [required.postCode, max.lengthPostCode(5), fiveDigitsPostcodeValidator],
    validationCleaner: stripCharacters(' '),
  },
];

export default FieldDefinitionIT;
